'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IconRight = exports.IconPlane = exports.IconPassengers = exports.IconPassenger = exports.IconMarker = exports.IconLoading = exports.IconLeft = exports.IconIncomplete = exports.IconDown = exports.IconCompleted = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pacomo = require('utils/pacomo');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconCompleted = exports.IconCompleted = function IconCompleted() {
    return _react2.default.createElement('div', { className: 'icon-completed' });
};

var IconDown = exports.IconDown = function IconDown() {
    return _react2.default.createElement('div', { className: 'icon-down', 'aria-hidden': 'false' });
};

var IconIncomplete = exports.IconIncomplete = function IconIncomplete() {
    return _react2.default.createElement('div', { className: 'icon-incomplete', 'aria-hidden': 'false' });
};

var IconLeft = exports.IconLeft = function IconLeft() {
    return _react2.default.createElement('i', { className: 'icon-left' });
};

var IconLoading = function IconLoading(_ref) {
    var inline = _ref.inline;

    return _react2.default.createElement(
        'div',
        { className: inline ? 'inline' : '' },
        _react2.default.createElement('div', null),
        _react2.default.createElement('div', null)
    );
};

exports.IconLoading = IconLoading = (0, _pacomo.pacomoTransformer)(IconLoading);

exports.IconLoading = IconLoading;
var IconMarker = exports.IconMarker = function IconMarker() {
    return _react2.default.createElement('div', { className: 'icon-marker' });
};

var IconPassenger = exports.IconPassenger = function IconPassenger() {
    return _react2.default.createElement('div', { className: 'icon-passenger', 'aria-hidden': 'false' });
};

var IconPassengers = exports.IconPassengers = function IconPassengers() {
    return _react2.default.createElement('div', { className: 'icon-passengers', 'aria-hidden': 'false' });
};

var IconPlane = exports.IconPlane = function IconPlane() {
    return _react2.default.createElement('div', { className: 'icon-plane' });
};

var IconRight = exports.IconRight = function IconRight() {
    return _react2.default.createElement('i', { className: 'icon-right' });
};


//////////////////
// WEBPACK FOOTER
// ./app/components/icons.js
// module id = 1352
// module chunks = 0